<template>
  <el-dialog
    :visible="show"
    width="80%"
    top="50px"
    title="报警弹框"
    @close="$emit('update:visible',false)"
  >
    <el-table
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 1)"
      height="60vh"
      :data="tableData"
      border
      stripe
      size="mini"
    >
      <el-table-column
        fixed
        prop="index"
        label="序号"
        width="50"
        align="center"
        v-slot="{ $index }"
      >
          <span>{{ (currentPage - 1) * pageSize + ($index + 1) }}</span>
      </el-table-column>
      <el-table-column
        prop="terminalNo"
        label="设备编号"
        min-width="100"
        align="center"
      />
      <el-table-column
        prop="groupName"
        label="所属组织"
        align="center"
        min-width="180"
      />
      <el-table-column
        prop="alarmTypeName"
        label="报警类型"
        align="center"
        min-width="180"
      />
      <el-table-column
        prop="alarmStartTime"
        label="报警开始时间"
        align="center"
        min-width="180"
      />

      <el-table-column
        prop="userName"
        label="用户名称"
        align="center"
        min-width="180"
      />
    </el-table>
    <el-pagination
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :page-sizes="[20, 50, 100]"
      @size-change="getData"
      @current-change="currentChange"
      layout="total,sizes, prev, pager, next, jumper"
      :total="total"
    />
  </el-dialog>
</template>
<script>
import day from "dayjs";
export default {
  name:'AlarmTable',
  props:{
    visible:{
      type:Boolean,
      default:false
    },
    id:{
      type:[Number,String],
      default:null
    }
  },
  data(){
    return {
      tableData:[],
      loading:false,
      currentPage: 1,
      pageSize: 100,
      total:0
    }
  },
  computed: {
    show:{
      get(){
        return this.visible
      },
      set(val){
        this.$emit('update:visible',val);
      }
    }
  },
  watch:{
    show:{
      handler(val){
        val && this.currentChange(1);
      },
      deep:true
    }
  },
  methods: {
    currentChange (val) {
      this.currentPage = val;
      this.getData();
    },
    async getData(){
      try{
        let params = {
          terminalNo:'',
          startTime: day().format(
            "YYYY-MM-DD 00:00:00:0"
          ),
          endTime: day().format(
            "YYYY-MM-DD 23:59:59:999"
          ),
          pageSize:this.pageSize,
          pageNumber:this.currentPage,
          alarmType:this.id
        };
        const { data, msg, code, total } = await this.$API.pageAlarmReport(params);
        if(code !== 0) throw { msg };
        this.tableData = data;
        this.total = total;
      }catch(err){
        this.$msg({
          showClose: true,
          message: err.msg,
          type: "error"
        });
      }
    },
  },
}
</script>
<style scoped>
.up_btn .el-upload{
  width: 100%;
}
.up_btn .el-upload__text{
  color:#FFF;
  width: 120px;
}
</style>
<style lang="scss" scoped>
.overflow{
  overflow: hidden;
}
.w_160{
  width: 160px;
}
.margin_top{
  margin-top: 10px;
}
.fl{
  float: left;
}
.fr{
  float: right !important;
}
.input_val{
  line-height: 40px;
  margin-left: 10px;
  span{
    display:inline-block;
    margin-right: 10px;
  }
}
.margin_bottom{
  margin-bottom:10px;
}
.up_btn{
  text-align: center;
  width:120px;
  float:left;
  line-height: 40px;
  border-radius: 6px;
  margin-right: 10px;
  color:#FFF;
  background: #00D3B8;
  .el-upload:active{
    color:#FFF;
  }
}
</style>
